import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = ({ config = {} }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const logoUrl = config.logoUrl || 'https://customer-assets.emergentagent.com/job_talentmgmt/artifacts/dyyu0c3k_Disen%CC%83o%20sin%20ti%CC%81tulo.png';
  const brandName = config.brandName || 'JG Models Agency';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    window.open('https://api.whatsapp.com/send?phone=573011920219&text=Hola,%20quiero%20información%20sobre%20JG%20Models', '_blank');
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/80 backdrop-blur-lg py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center hover:opacity-80 transition-opacity">
            {logoUrl ? (
              <img 
                src={logoUrl}
                alt={brandName} 
                className="h-20 w-auto"
              />
            ) : (
              <span className="text-2xl font-bold text-[#c8784e]">{brandName}</span>
            )}
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <a href="#inicio" className="text-white hover:text-[#c8784e] transition-colors font-medium">
              Inicio
            </a>
            <a href="#servicios" className="text-white hover:text-[#c8784e] transition-colors font-medium">
              Servicios
            </a>
            <a href="#proceso" className="text-white hover:text-[#c8784e] transition-colors font-medium">
              Proceso
            </a>
            <Link to="/contact" className="text-white hover:text-[#c8784e] transition-colors font-medium">
              Contacto
            </Link>
            <Link to="/login" className="text-white hover:text-[#c8784e] transition-colors font-medium">
              Empleados
            </Link>
            <button
              onClick={handleWhatsAppClick}
              className="bg-[#c8784e] text-black px-6 py-2 rounded-full font-semibold hover:bg-[#d89a6f] transition-all duration-300 hover:scale-105"
            >
              Postular Ahora
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 flex flex-col gap-4 bg-black/90 p-6 rounded-lg">
            <a href="#inicio" className="text-white hover:text-[#c8784e] transition-colors font-medium">
              Inicio
            </a>
            <a href="#servicios" className="text-white hover:text-[#c8784e] transition-colors font-medium">
              Servicios
            </a>
            <a href="#proceso" className="text-white hover:text-[#c8784e] transition-colors font-medium">
              Proceso
            </a>
            <Link to="/contact" className="text-white hover:text-[#c8784e] transition-colors font-medium">
              Contacto
            </Link>
            <Link to="/login" className="text-white hover:text-[#c8784e] transition-colors font-medium">
              Empleados
            </Link>
            <button
              onClick={handleWhatsAppClick}
              className="bg-[#c8784e] text-black px-6 py-3 rounded-full font-semibold text-center hover:bg-[#d89a6f] transition-all duration-300"
            >
              Postular Ahora
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;